import React from 'react';

const PageHeader = ({name, description}) => {
    return (
        <>
            {/* PAGE-HEADER */}
            <div className="page-header mb-4">
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <h1 className="page-title">{name}</h1>
                        <p className="text-muted mb-0">{description}</p> 
                    </div>
                    <div>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <a href="#">Admin</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {name}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            {/* PAGE-HEADER END */}
        </>
    );
};

export default PageHeader;
